import React from "react";

import ScorecardsTable from "pages/Fleet/Scorecards/Table";

export const Scorecards = () => {
  return (
        <ScorecardsTable />
  );
};
